Ext.define('SA.BeyondLimitBusinessesMessage', {
    alias: 'widget.beyond-limit-businesses-message',
    extend: 'Ext.Component',

    cls: 'sa-beyond-limit-businesses-message',

    tpl: [
        '<svg class="sa-beyond-limit-businesses-message-svg">',
            '<use href="#sa-icon-warning"></use>',
        '</svg>',
        '<div>',
            '<div class="sa-beyond-limit-businesses-message-primary-text">',
                'SimplyAnalytics users can export a maximum of {perExport.limit:formatValue("%d")} ',
                'businesses per export, {perWeek.limit:formatValue("%d")} businesses per week, and ',
                '{perYear.limit:formatValue("%d")} businesses per year.',
            '</div>',
            '<div>',
                'With this report, you would be exporting <strong>{proposedUse:formatValue("%d")} ',
                'businesses now ({perExport.wouldBeUsedPercent:formatValue("%d")}% of limit)</strong>, ',
                'and would have exported <strong>{perWeek.wouldBeUsed:formatValue("%d")} businesses ',
                'this week ({perWeek.wouldBeUsedPercent:formatValue("%d")}% of limit)</strong> and ',
                '<strong>{perYear.wouldBeUsed:formatValue("%d")} businesses this year ',
                '({perYear.wouldBeUsedPercent:formatValue("%d")}% of limit)</strong>.',
            '</div>',
        '</div>'
    ]
});